import Bold from 'quill/formats/bold';
import { Code as QuillCode } from 'quill/formats/code';
import QuillHeader from 'quill/formats/header';

export default class Code extends QuillCode {
  enforceAllowedChildren() {
    super.enforceAllowedChildren();

    if (this.parent && this.parent.statics.blotName === QuillHeader.blotName) {
      this.children.forEach((child) => {
        if (child instanceof Bold) {
          child.format(Bold.blotName, null);
        }
      });
    }
  }
}
